import React from 'react';
import { useTravelers } from '../../../../../context/travelersContext';
import { AgeBand, Experience } from '../../../../../context/dataExperienceContext';
import { getAgeBandLabel } from '../label-helpers';
import Dropdown from '../../../../../components/Dropdown';
import TravelersSelector from './TravelersSelector';
import './styles.scss';
import { Button } from 'antd';

export const Travelers = ({ product }: {
    product: {
        pricingInfo: Experience['product']['pricingInfo'],
        bookingRequirements: Experience['product']['bookingRequirements'],
        cancellationPolicy: Experience['product']['cancellationPolicy'],
    }
}) => {

    const { travelers } = useTravelers();

    const getTotalTravelersText = () => {
        const ageBands: AgeBand[] = ['ADULT', 'SENIOR', 'YOUTH', 'CHILD', 'INFANT', 'TRAVELER'];
        const travelersText = ageBands
            .filter(ageBand => travelers[ageBand] && (travelers[ageBand] > 0))
            .map(ageBand => {
                const count = travelers[ageBand];
                const label = getAgeBandLabel(ageBand);
                return `${count} ${count === 1 ? label : label + 's'}`;
            })
            .join(', ');

        return travelersText || 'Seleccionar viajeros';
    };


    return <Dropdown
        trigger={['click']}
        dropdownRender={(
            <TravelersSelector
                pricingInfo={product.pricingInfo}
                bookingRequirements={product.bookingRequirements}
            />
        )}
    >
        <Button className="selected-travelers">
            {getTotalTravelersText()}
        </Button>
    </Dropdown>
}
